(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentHistory', DocumentHistoryDirective)
		.controller('smbDocumentHistoryController', [
			'pxProgressService',
			'smbDocumentHistoryDataStore',
			'gettextCatalog',
			'pxAuthService',
			'sbToastService',
			'sbDocumentDetailService',
			'smbDocumentDataStore',
			'smbContentUploadDataStore',
			DocumentHistoryController
		]);

	var templateUrl = require('./documentHistory.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.documentHistory
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * @usage
	 *
	 * <smb-document-indexes />
	 */
	function DocumentHistoryDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentHistoryController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				documentId: '@',
				contentTypeId: '@'
			},
			link: function (scope) {
				scope.$watch('vm.activeTab',function (newVal) {
					if (newVal === 1 && scope.vm.docRevisions.length === 0) {
						scope.vm.loadRevisions();
					}
				});
			}
		};
	}

	function DocumentHistoryController(pxProgressService, smbDocumentHistoryDataStore, gettextCatalog, pxAuthService, sbToastService, sbDocumentDetailService, smbDocumentDataStore, smbContentUploadDataStore) {
		var vm = this;
		vm.loading = false;
		vm.documentHistoryDS = smbDocumentHistoryDataStore;
		vm.activeTab = 0;

		vm.documentDS = smbDocumentDataStore;
		vm.docRevisions = [];
		vm.promoteRevision = promoteRevision;
		vm.isLatest = isLatest;
		vm.uploadRevision = uploadRevision;
		vm.loadRevisions = loadRevisions;

		(function initDocumentIndexesController() {
			vm.loading = true;
			pxProgressService.visible = true;
			vm.documentHistoryDS.loadHistory(vm.documentId, vm.documentTypeId, false)
				.finally(function() {
					vm.loading = false;
					pxProgressService.visible = false;
				});
		}());

		function loadRevisions() {
			return sbDocumentDetailService.getVersions(vm.documentId)
				.then(function (revisions) {
					vm.docRevisions = revisions.map(function (v) {
						return Object.assign({}, v, {
							DateCreated: new Date(v.DateCreated),
							CreatedBy: v.CreatedBy === pxAuthService.displayName ? 'You' : v.CreatedBy
						});
					});
					return revisions;
				}).then(function () {
					var latest = vm.docRevisions[vm.docRevisions.length - 1];
					var originalFileName = latest.OriginalFileName.split('.');
					vm.extension = originalFileName[originalFileName.length - 1];
					vm.extension = vm.extension && '.' + vm.extension;
				});
		}

		function promoteRevision(ev, revision) {
			ev.preventDefault();
			ev.stopPropagation();
			smbContentUploadDataStore.promoteRevision(revision)
				.then(function () {
					return loadRevisions();
				})
				.then(function () {
					sbToastService.showSimple(gettextCatalog.getString('Successfully made revision {rev} the current revision'.replace('{rev}', revision.VersionNumber)));
				});
		}

		function isLatest(revision) {
			return vm.docRevisions.indexOf(revision) === vm.docRevisions.length - 1;
		}

		function uploadRevision(fileInput) {
			if (!fileInput.files.length) {
				// no files have been selected, don't try to upload
				// non-existant file
				return;
			}

			var file = fileInput.files[0];
			smbContentUploadDataStore.uploadRevision(vm.documentId, file)
				.then(function () { /* Reload revisions after creating new one. */
					return loadRevisions();
				})
				.then(function () { /* Reset file input and display success message */
					sbToastService.showSimple(gettextCatalog.getString('New revision saved'));
				})
				.catch(function (err) {
					// show error message
					sbToastService.showSimple(err.data.Message);
				})
				.finally(function () { /* Reset file input */
					fileInput.value = '';
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentHistory/documentHistory.js
// module id = 81
// module chunks = 1